import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import {CertFormType} from 'components/dialogs/CertDialog';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {useToasts} from 'features/notifications/useToasts';
import React from 'react';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {licenseTypes} from '..';

export const useUploadLicense = (closeCertDialog: () => void) => {
   const url = api.licenseUpload;

   const dispatch = useDispatch();
   const {request} = usePostApi(url);
   const {addToast} = useToasts();

   const onSuccess = React.useCallback(
      (data) => {
         closeCertDialog();

         dispatch(action(licenseTypes.GET_LICENSE.SUCCESS, data));
         addToast(`New license applied`, {appearance: 'success'});
      },
      [closeCertDialog]
   );

   const handleUpload = React.useCallback(
      (values?: CertFormType, helpers?: FormOnSubmitHelpers<CertFormType>) => {
         if (values) {
            request(
               JSON.stringify({
                  licenseText: values.body,
               }),
               {onSuccess}
            );
         } else {
            closeCertDialog();
         }
      },
      [request, closeCertDialog, onSuccess]
   );

   return handleUpload;
};
